<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title>Service Diagnostics</v-toolbar-title>

      <v-spacer />

      <template v-slot:extension>
        <v-tabs v-model="tab" align-with-title>
          <v-tabs-slider color="yellow" />

          <v-tab
            v-for="item in getFilteredItems"
            :key="item"
            @change="changeTabs()"
          >
            {{ item }}
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>

    <v-tabs-items v-model="tab">
      <v-tab-item v-for="item in getFilteredItems" :key="item">
        <v-card flat class="text-center">

          <!-- AVC -->
          <div>
            <p class="custom-p text-right font-weight-bold" :class="addClass">
              AVC ID:
            </p>
            <p class="custom-p">
              <span v-html="tier1"></span> {{ AvcId }}
            </p>
          </div>

          <!-- ACTIONS -->
          <div class="mb-7">
            <v-btn class="primary" @click="submit(item, AvcId)">
              Run Test
            </v-btn>
            &nbsp;&nbsp;
            <v-btn class="primary" @click="getTestResult(item, AvcId)">
              Query Result
            </v-btn>
          </div>

          <!-- NO RESULT -->
          <div v-if="showHasNoServiceResult">
            <p class="custom-p text-right font-weight-bold" :class="addClass">
              No Service Test Result received from NBN, please try again later
            </p>
          </div>

          <div v-else>
            <p class="custom-p">&nbsp;</p>
          </div>

          <!-- RESULT BLOCK -->
          <div style="overflow-x: auto" v-if="showResult">
          
            <div class="custom-div serviceable">
              <app-heading :text="'Service Test Result'" :heading="'main'" />
            
              <div ref="result">
              
                <!-- STATUS -->
                <div>
                  <p class="custom-p text-right font-weight-bold" :class="addClass">
                    Status:
                  </p>
                  <p class="custom-p">
                    <span v-html="tier1"></span>
                    {{ normalizedLineState.status }}
                  </p>
                </div>
              
                <!-- RESULT -->
                <div v-if="normalizedLineState.status === 'Completed'">
                  <p class="custom-p text-right font-weight-bold" :class="addClass">
                    Result:
                  </p>
                  <p class="custom-p">
                    <span v-html="tier1"></span>
                    {{ normalizedLineState.result }}
                  </p>
                </div>
              
                <!-- DLM Operational State -->
                <div
                  v-if="
                    normalizedLineState.type === 'Dynamic Line Management Status' &&
                    normalizedLineState.status === 'Completed'
                  "
                >
                  <p class="custom-p text-right font-weight-bold" :class="addClass">
                    DLM Operational State:
                  </p>
                  <p class="custom-p">
                    <span v-html="tier1"></span>
                    {{ normalizedLineState.dlmOperationalState }}
                  </p>
                </div>
              
                <!-- Generic Measurements -->
                <div
                  v-if="
                    [
                      'UNI-D Status',
                      'NTD Status',
                      'WNTD Status',
                      'NCD UNI-D Status',
                      'DPU Status',
                      'DPU Port Status',
                      'Dynamic Line Management Status'
                    ].includes(normalizedLineState.type) &&
                    normalizedLineState.status === 'Completed'
                  "
                >
                  <div
                    v-for="(item, i) in normalizedLineState.displayMeasurements"
                    :key="'measurement-' + i"
                  >
                    <p class="custom-p text-right font-weight-bold" :class="addClass">
                      {{ item.id }}:
                    </p>
                    <p class="custom-p">
                      <span v-html="tier1"></span>
                      {{ item.value }}
                    </p>
                  </div>
                </div>
              
                <!-- DLM State History -->
                <div
                  v-if="
                    normalizedLineState.type === 'Dynamic Line Management Status' &&
                    normalizedLineState.status === 'Completed'
                  "
                >
                  <div
                    v-for="(history, h) in normalizedLineState.dlmStateHistory"
                    :key="'dlm-history-' + h"
                  >
                    <p class="custom-p text-right font-weight-bold" :class="addClass">
                      Timestamp:
                    </p>
                    <p class="custom-p">
                      <span v-html="tier1"></span>
                      {{ history.timestamp }}
                    </p>
                  
                    <div
                      v-for="(item, i) in history.measurements"
                      :key="'dlm-history-' + h + '-' + i"
                    >
                      <p class="custom-p text-right font-weight-bold" :class="addClass">
                        {{ item.id }}:
                      </p>
                      <p class="custom-p">
                        <span v-html="tier1"></span>
                        {{ item.value }}
                      </p>
                    </div>
                  
                    <br />
                  </div>
                </div>
              
                <!-- LINE STATE DIAGNOSTIC -->
                <div
                  v-if="
                    normalizedLineState.type === 'Line State Diagnostic' &&
                    normalizedLineState.status === 'Completed'
                  "
                >
                  <div
                    v-for="(item, i) in normalizedLineState.serviceStateHistory"
                    :key="'ssh-' + i"
                  >
                    <p class="custom-p text-right font-weight-bold" :class="addClass">
                      {{ item.id }}:
                    </p>
                    <p class="custom-p">
                      <span v-html="tier1"></span>
                      {{ item.value }}
                    </p>
                  </div>
                
                  <div
                    v-for="(item, i) in normalizedLineState.serviceDetails"
                    :key="'sd-' + i"
                  >
                    <p class="custom-p text-right font-weight-bold" :class="addClass">
                      {{ item.id }}:
                    </p>
                    <p class="custom-p">
                      <span v-html="tier1"></span>
                      {{ item.value }}
                    </p>
                  </div>
                
                  <div
                    v-for="(item, i) in normalizedLineState.cpe"
                    :key="'cpe-' + i"
                  >
                    <p class="custom-p text-right font-weight-bold" :class="addClass">
                      {{ item.id }}:
                    </p>
                    <p class="custom-p">
                      <span v-html="tier1"></span>
                      {{ item.value }}
                    </p>
                  </div>
                
                  <div
                    v-for="(item, i) in normalizedLineState.copperPair"
                    :key="'cp-' + i"
                  >
                    <p class="custom-p text-right font-weight-bold" :class="addClass">
                      {{ item.id }}:
                    </p>
                    <p class="custom-p">
                      <span v-html="tier1"></span>
                      {{ item.value }} {{ item.unit }}
                    </p>
                  </div>
                
                  <div
                    v-for="(item, i) in normalizedLineState.performance"
                    :key="'perf-' + i"
                  >
                    <p class="custom-p text-right font-weight-bold" :class="addClass">
                      {{ item.id }} {{ item.name || "" }} {{ item["@type"] }}
                    </p>
                    <p class="custom-p">
                      <span v-html="tier1"></span>
                      {{ item.value }} {{ item.unit }}
                    </p>
                  </div>
                </div>
              
                <!-- SINGLE END LINE TEST -->
                <div
                  v-if="
                    normalizedLineState.type === 'Single End Line Test' &&
                    normalizedLineState.status === 'Completed'
                  "
                >
                  <!-- Estimates Loop -->
                  <div
                    v-for="(item, i) in normalizedLineState.estimatesLoop"
                    :key="'loop-' + i"
                  >
                    <p class="custom-p text-right font-weight-bold" :class="addClass">
                      {{ item.id }}:
                    </p>
                    <p class="custom-p">
                      <span v-html="tier1"></span>
                      {{ item.value }} {{ item.unit || "" }}
                    </p>
                  </div>
                
                  <!-- Performance -->
                  <div
                    v-for="(item, i) in normalizedLineState.performance"
                    :key="'selt-perf-' + i"
                  >
                    <p class="custom-p text-right font-weight-bold" :class="addClass">
                      {{ item.id }}:
                    </p>
                    <p class="custom-p">
                      <span v-html="tier1"></span>
                      {{ item.value }} {{ item.unit || "" }}
                    </p>
                  </div>
                
                  <!-- Bridge Tap -->
                  <div
                    v-for="(item, i) in normalizedLineState.bridgeTap"
                    :key="'bridge-' + i"
                  >
                    <p class="custom-p text-right font-weight-bold" :class="addClass">
                      {{ item.id }}:
                    </p>
                    <p class="custom-p">
                      <span v-html="tier1"></span>
                      {{ item.value }} {{ item.unit || "" }}
                    </p>
                  </div>
                
                  <!-- Service Problems -->
                  <div
                    v-for="(problem, p) in normalizedLineState.serviceProblems"
                    :key="'problem-' + p"
                  >
                    <p class="custom-p text-right font-weight-bold" :class="addClass">
                      Problem Description:
                    </p>
                    <p class="custom-p">
                      <span v-html="tier1"></span>
                      {{ problem.problemDescription }}
                    </p>
                  
                    <p class="custom-p text-right font-weight-bold" :class="addClass">
                      Impact:
                    </p>
                    <p class="custom-p">
                      <span v-html="tier1"></span>
                      {{ problem.impactImportanceFactor }}
                    </p>
                  
                    <div
                      v-for="(detail, d) in problem.details"
                      :key="'problem-' + p + '-detail-' + d"
                    >
                      <p class="custom-p text-right font-weight-bold" :class="addClass">
                        {{ detail.id }}:
                      </p>
                      <p class="custom-p">
                        <span v-html="tier1"></span>
                        {{ detail.value }} {{ detail.unit || "" }}
                      </p>
                    </div>
                  
                    <br />
                  </div>
                </div>
              
              </div>
            </div>
          </div>
        </v-card>
      </v-tab-item>
    </v-tabs-items>

    <http-response
      v-if="showResult"
      :text="httpText"
      :color="httpColor"
      :isActive="httpIsActive"
    />
  </v-card>
</template>

<script>
export default {
  name: "nbn-service-diagnostics",

  props: {
    AvcId: String,
    OrderType: String
  },

  data: () => ({
    tab: null,
    showResult: false,
    showHasNoServiceResult: false,
    serviceTestResult: {},
    tier1: "&nbsp;"
  }),

  computed: {
    getFilteredItems() {
      const t = this.OrderType;

      const FTTN_TESTS = ["Line state", "LQD", "SELT", "Loopback Test", "Port Reset"];
      const HFC_TESTS = ["NTD Status", "NTD Reset", "Loopback Test"];
      const FTTP_TESTS = ["NTD Status", "UNI-D Status", "Port Reset", "Loopback Test"];
      const FTTC_TESTS = [
        "NCD UNI-D Status",
        "NCD Reset",
        "NCD Port Reset",
        "DPU Status",
        "DPU Port Status",
        "DPU Port Reset",
        "Loopback Test",
      ];

      const SERVICE_TESTS = {
        FTTN: FTTN_TESTS,
        FTTB: FTTN_TESTS,
        HFC: HFC_TESTS,
        "Fixed Wireless": HFC_TESTS,
        Fibre: FTTP_TESTS,
        FTTP: FTTP_TESTS,
        FTTC: FTTC_TESTS,
      };
    
      return SERVICE_TESTS[t] ?? [];
    },
    normalizedLineState() {
      const root = this.serviceTestResult || {};
      const t = Array.isArray(root.testMeasure) ? root.testMeasure[0] : {};

      const measurements = (obj) =>
        Array.isArray(obj?.measurements) ? obj.measurements : [];

      const serviceDetailsMeasurements = measurements(t.serviceDetails);
      const performanceMeasurements = measurements(t.performance);

      // SELT
      const estimatesLoopMeasurements = measurements(t.estimatesLoop);
      const bridgeTapMeasurements = measurements(t.bridgeTap);
      const serviceProblems = Array.isArray(t.serviceProblem)
        ? t.serviceProblem
        : [];

      const containerKeys = [
        "ntd",
        "serviceDetails",
        "serviceStateHistory",
        "cpe",
        "copperPair",
        "performance",
        "dlmStateHistory",
      ];
          
      const hasContainers = containerKeys.some(key => key in t);
          
      const hasFlatMeasurements =
        Object.keys(t).length > 0 &&
        !hasContainers;

      const commonLabelMap = {
        // UNI-D Status
        unidEthernetPortNumber: "Port Number",
        unidEthernetPortOperationalState: "Operational State",
        unidEthernetPortLinkState: "Link State",
        unidEthernetPortCurrentState: "Current State",
        unidEthernetConfigStatus: "Configuration State",
        unidVlanMacAddress: "MAC Address",
      
        // DPU Status
        dpuOperationalState: "DPU Operational State",
        enniCVlan: "ENNI C-VLAN",
        enniSVlan: "ENNI S-VLAN",
      
        // DPU Port Status
        dpuPortNumber: "DPU Port Number",
        reversePowerState: "Reverse Power State",
        accessLineRate: "Access Line Rate",
        xdslSyncState: "xDSL Sync State",
      
        // DLM
        dlmOperationalState: "DLM Operational State"
      };
    
      const testSpecificLabelMaps = {
        "NCD UNI-D Status": {
          ethernetPortOperationalState: "NCD UNI-D Port Operational State",
          ethernetPortCurrentBitRate: "NCD UNI-D Port Current Bit Rate",
          ethernetPortMaxBitRate: "NCD UNI-D Port Max Bit Rate",
          ethernetPortConfiguredDuplexMode:
            "NCD UNI-D Ethernet Port Configuration",
          ethernetPortCurrentDuplexMode:
            "NCD UNI-D Ethernet Port Speed and Duplex"
        },
      
        "DPU Port Status": {
          ethernetPortOperationalState: "DPU Port Operational State"
        }
      };
    
      const labelMap = {
        ...commonLabelMap,
        ...(testSpecificLabelMaps[root.type] || {})
      };
    
      const formatLabel = (key) => {
        if (Object.prototype.hasOwnProperty.call(labelMap, key)) {
          return labelMap[key];
        }
      
        return key
          .replace(/([A-Z])/g, " $1")
          .replace(/^./, (s) => s.toUpperCase());
      };
    
      let displayMeasurements = [];
    
      if (hasFlatMeasurements) {
        displayMeasurements = Object.entries(t)
          .filter(([key]) => key !== "type")
          .map(([key, value]) => ({
            id: formatLabel(key),
            value
          }));
      } else if (root.type === "NTD Status") {
        displayMeasurements = measurements(t.ntd);
      } else if (root.type === "Dynamic Line Management Status") {
        displayMeasurements = performanceMeasurements;
      } else {
        displayMeasurements = serviceDetailsMeasurements;
      }
    
      return {
        type: root.type || "",
        status: root.status || "",
        result: root.result || "",
        errorReason: root?.errors?.[0]?.reason || "",
      
        raw: t,
      
        rawMeasurements: serviceDetailsMeasurements,
      
        ntdMeasurements: measurements(t.ntd),
        serviceStateHistory: measurements(t.serviceStateHistory),
        serviceDetails: serviceDetailsMeasurements,
        cpe: measurements(t.cpe),
        copperPair: measurements(t.copperPair),
      
        performance: performanceMeasurements,
      
        // SELT
        estimatesLoop: estimatesLoopMeasurements,
        bridgeTap: bridgeTapMeasurements,
        serviceProblems,
      
        // DLM
        dlmOperationalState: t.performance?.dlmOperationalState || "",
        dlmStateHistory: Array.isArray(t.dlmStateHistory)
          ? t.dlmStateHistory
          : [],
      
        displayMeasurements
      };
    }
  },

  methods: {
    submit(item, avcId) {
      let vm = this;
      let payload = {};
      let tstId = "";

      const testMap = {
        "Line state": "TST000000001004",
        "Port Reset": "TST000000002008",
        "UNI-D Status": "TST000000001008",
        "NCD UNI-D Status": "TST000000001005",
        "DPU Status": "TST000000001002",
        "NCD Reset": "TST000000002005",
        "DPU Port Reset": "TST000000002012",
        "Loopback Test": "TST000000002002",
        "DPU Port Status": "TST000000001001",
        "NCD Port Reset": "TST000000002004",
        "LQD": "TST000000001003",
        "SELT": "TST000000002009",
        "NTD Status": {
          HFC: "TST000000001017",
          "Fixed Wireless": "TST000000001010",
          "FTTP": "TST000000001007",
          "Fibre": "TST000000001007",
        },
        "NTD Reset": {
          HFC: "TST000000002006",
          "Fixed Wireless": "TST000000002011",
        },
      };

      const mapping = testMap[item];

      if (typeof mapping === "string") {
        tstId = mapping;
      } else if (mapping) {
        tstId = mapping[vm.OrderType] ?? tstId;
      }

      payload = {
        TestDetails: {
          externalId: "ABC-123",
          serviceRef: {
            id: avcId,
            type: "AVC"
          },
          testSpecificationRef: {
            id: tstId,
            version: "1.0"
          },
          ...(item === "SELT" && {
            testParameters: {
              forceMeasurement: true
            }
          })
        },
        TestType: item
      };

      vm.submitServiceTest(payload)
      .then(data => {
        if (data) {
          let responsePayload = {
            text:
              "Successfully submitted the service test request, " +
              "it might take a few minutes to get the results," +
              " please try click the button 'QUERY RESULT' later",
            color: "success"
          };
        
          vm.setHttpResponse(responsePayload);
        } else {
          vm.setHttpResponse({
            text: "Failed to submit the service test",
            color: "error"
          });
        }
      })
      .catch(() => {
        vm.setHttpResponse({
          text: "Failed to submit the service test",
          color: "error"
        });
      });
    },

    changeTabs() {
      this.serviceTestResult = {};
      this.showHasNoServiceResult = false;
      this.showResult = false;
    },

    addClass() {
      return (this.$route.path === "/" || this.$route.path === "/nbn-orders")
        ? "first-order"
        : "first-sq";
    },

    getTestResult(item, avcId) {
      let vm = this;
      let payload = { AvcId: avcId, TestType: item };

      vm.getServiceTestResult(payload).then(data => {
        if (!data) {
          vm.showHasNoServiceResult = true;
          return;
        }

        let json;

        try {
          json = JSON.parse(data.serviceTestBody || "{}");
        } catch (e) {
          vm.showHasNoServiceResult = true;
          return;
        }

        vm.serviceTestResult =
          json?.event?.serviceTest?.serviceTestResults?.[0] || {};

        vm.showResult = true;
      });
    }
  }
};
</script>

<style scoped>
.custom-div {
  border: 2px solid #9e9e9e;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 15px;
  font-size: 15px !important;
}

.row-border {
  border-top: 1px solid #9e9e9e;
}

.custom-p {
  display: inline-block;
  margin-bottom: 2px;
}

.first-sq {
  width: 513px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: top;
}

.first-order {
  width: 445px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: top;
  width: 37%;
}

@media screen and (max-width: 1100px) {
  .custom-div {
    width: 1100px;
  }
}
</style>
